import { render, staticRenderFns } from "./OrdersTags.container.vue?vue&type=template&id=903d3b66&scoped=true&"
import script from "./OrdersTags.container.vue?vue&type=script&lang=js&"
export * from "./OrdersTags.container.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTags.container.vue?vue&type=style&index=0&id=903d3b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903d3b66",
  null
  
)

export default component.exports